/* Aksesuarlia — storefront behaviour for the Concept 03 theme. No dependencies. */
(() => {
  'use strict';

  const config = (() => {
    try { return JSON.parse(document.getElementById('theme-config').textContent); } catch (error) { return { strings: {} }; }
  })();
  const strings = config.strings || {};
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = config.rootUrl && config.rootUrl !== '/' ? config.rootUrl.replace(/\/$/, '') + '/' : '/';

  /* ------------------------------------------ native market localization */
  $$('[data-country-select]').forEach((select) => select.addEventListener('change', () => select.form?.requestSubmit()));

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-language-choice]');
    if (!choice) return;
    try {
      localStorage.setItem('aksesuarlia_language_choice', choice.value);
      localStorage.setItem('aksesuarlia_language_initialized', '1');
    } catch (_) { /* Storage may be unavailable; Shopify still persists the form choice. */ }
  });

  document.addEventListener('click', (event) => {
    $$('[data-language-dropdown][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const dropdown = $('[data-language-dropdown][open]');
    if (!dropdown) return;
    dropdown.removeAttribute('open');
    $('summary', dropdown)?.focus({ preventScroll: true });
  });

  (() => {
    const form = $('[data-localization-form]');
    if (!form) return;
    let initialized = false;
    let explicitChoice = '';
    try {
      initialized = localStorage.getItem('aksesuarlia_language_initialized') === '1';
      explicitChoice = localStorage.getItem('aksesuarlia_language_choice') || '';
    } catch (_) { return; }
    if (initialized || explicitChoice) return;

    const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language || ''];
    const russianPreferred = browserLanguages.some((language) => /^ru(?:-|$)/i.test(language));
    const country = (form.dataset.currentCountry || window.Shopify?.country || '').toUpperCase();
    const desired = russianPreferred ? 'ru' : country === 'TR' ? 'tr' : 'en';
    const target = $(`[data-language-choice][value="${desired}"]`, form);
    try { localStorage.setItem('aksesuarlia_language_initialized', '1'); } catch (_) { return; }
    if (target && desired !== form.dataset.currentLanguage) target.click();
  })();

  /* ---------------------------------------------------------------- money */
  function formatMoney(cents, format = config.moneyFormat || '{{amount}}') {
    const value = Number(cents) || 0;
    const fmt = (amount, decimals, thousands = '.', decimal = ',') => {
      const fixed = (amount / 100).toFixed(decimals);
      const [whole, fraction] = fixed.split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  /* --------------------------------------------------------------- panels */
  const backdrop = $('[data-backdrop]');
  let activePanel = null;
  let lastTrigger = null;
  const focusable = (el) => $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
    .filter((node) => node.offsetParent !== null || node === document.activeElement);

  function openPanel(id, trigger) {
    if (id === 'cart-drawer' && config.cartDrawer === false) { window.location.href = config.cartUrl || '/cart'; return; }
    const panel = document.getElementById(id);
    if (!panel) return;
    if (activePanel && activePanel !== panel) closePanel(false);
    activePanel = panel;
    lastTrigger = trigger || document.activeElement;
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    backdrop?.classList.add('show');
    $$(`[data-open="${id}"]`).forEach((button) => button.setAttribute('aria-expanded', 'true'));
    const target = $('[data-search-input]', panel) || focusable(panel)[0];
    window.setTimeout(() => target?.focus({ preventScroll: true }), 60);
  }

  function closePanel(restoreFocus = true) {
    if (!activePanel) return;
    const id = activePanel.id;
    activePanel.classList.remove('open');
    activePanel.setAttribute('aria-hidden', 'true');
    backdrop?.classList.remove('show');
    $$(`[data-open="${id}"]`).forEach((button) => button.setAttribute('aria-expanded', 'false'));
    activePanel = null;
    if (restoreFocus && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open]');
    if (opener) {
      event.preventDefault();
      openPanel(opener.dataset.open, opener);
      return;
    }
    if (event.target.closest('[data-close]') && event.target.closest('[data-panel]')) {
      closePanel();
      return;
    }
    if (event.target.closest('[data-backdrop]')) closePanel();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activePanel && !zoom.modal) closePanel();
    if (event.key === 'Tab' && activePanel) {
      const nodes = focusable(activePanel);
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  // Mobile menu links close the menu before navigating (same-page anchors included).
  $$('#mobile-menu a').forEach((link) => link.addEventListener('click', () => closePanel(false)));

  /* --------------------------------------------------------- announcement */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement-ticker > span', bar);
    if (items.length < 2 || reducedMotion) return;
    const interval = Number(bar.dataset.interval) || 4800;
    let index = 0;
    let paused = false;
    bar.addEventListener('mouseenter', () => { paused = true; });
    bar.addEventListener('mouseleave', () => { paused = false; });
    bar.addEventListener('focusin', () => { paused = true; });
    bar.addEventListener('focusout', () => { paused = false; });
    window.setInterval(() => {
      if (paused || document.hidden) return;
      items[index].classList.remove('is-active');
      items[index].setAttribute('aria-hidden', 'true');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
      items[index].removeAttribute('aria-hidden');
    }, interval);
  });

  /* ---------------------------------------------------------- hero slider */
  $$('[data-hero]').forEach((hero) => {
    const visuals = $$('[data-slide]', hero);
    const dots = $$('[data-slide-to]', hero);
    const copy = $('[data-hero-copy]', hero);
    if (visuals.length < 2) return;
    let active = 0;
    let touchX = null;

    function bindFill(fill) {
      fill.addEventListener('animationend', () => show(active + 1), { once: true });
    }

    function show(index) {
      const next = (index + visuals.length) % visuals.length;
      if (next === active) return;
      active = next;
      visuals.forEach((visual, i) => { visual.hidden = i !== active; });
      const template = $(`template[data-slide-copy="${active}"]`, hero);
      if (template && copy) copy.replaceChildren(template.content.cloneNode(true));
      dots.forEach((dot, i) => {
        const on = i === active;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        const bar = $('span', dot);
        bar.replaceChildren();
        if (on) {
          const fill = document.createElement('i');
          bar.appendChild(fill);
          bindFill(fill);
        }
      });
    }

    const firstFill = $('.is-active i', hero);
    if (firstFill) {
      firstFill.getAnimations?.().forEach((animation) => { animation.currentTime = 0; animation.play(); });
      bindFill(firstFill);
    }
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.slideTo))));
    $('[data-slide-prev]', hero)?.addEventListener('click', () => show(active - 1));
    $('[data-slide-next]', hero)?.addEventListener('click', () => show(active + 1));
    hero.addEventListener('mouseenter', () => hero.classList.add('is-paused'));
    hero.addEventListener('mouseleave', () => hero.classList.remove('is-paused'));
    hero.addEventListener('touchstart', (event) => { touchX = event.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (event) => {
      if (touchX === null) return;
      const distance = event.changedTouches[0].clientX - touchX;
      if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1));
      touchX = null;
    });
  });

  /* ------------------------------------------------------------------ cart */
  const cartJsonUrl = (config.cartUrl || '/cart') + '.js';

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((badge) => { badge.textContent = count; badge.hidden = count === 0; });
    $$('[data-cart-count-plain]').forEach((node) => { node.textContent = count; });
    $$('[data-open="cart-drawer"]').forEach((link) => link.setAttribute('aria-label', `${strings.cart || ''}, ${count}`));
  }

  function renderDrawer(html) {
    const drawer = $('[data-cart-drawer]');
    if (!drawer || !html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
    if (fresh) drawer.replaceChildren(...fresh.childNodes);
  }

  async function refreshCart(sectionsHtml) {
    if (sectionsHtml) renderDrawer(sectionsHtml);
    try {
      const cart = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      updateCartCount(cart.item_count);
      return cart;
    } catch (error) { return null; }
  }

  async function changeLine(line, quantity) {
    const drawer = $('[data-cart-drawer]');
    drawer?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${config.cartChangeUrl || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: 'cart-drawer', sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || strings.cartError);
      renderDrawer(data.sections && data.sections['cart-drawer']);
      updateCartCount(data.item_count);
      if (document.querySelector('[data-cart-page]')) window.location.reload();
    } catch (error) {
      const status = $('[data-cart-status]');
      if (status) status.textContent = error.message || strings.cartError || '';
    } finally {
      $('[data-cart-drawer]')?.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-drawer] [data-qty]');
    if (!button) return;
    const line = button.closest('[data-line]');
    if (!line) return;
    changeLine(Number(line.dataset.line), Math.max(0, Number(button.dataset.qty)));
  });

  async function addToCart(form) {
    const status = $('[data-form-status]', form.closest('[data-product-root]') || document);
    const buttons = [...$$('[data-add-button]', form), ...$$(`[data-add-button][form="${form.id}"]`)];
    buttons.forEach((button) => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    if (status) status.textContent = '';
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      const response = await fetch(`${config.cartAddUrl || '/cart/add'}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || strings.cartError);
      await refreshCart(data.sections && data.sections['cart-drawer']);
      if (status) status.textContent = strings.addedToCart || '';
      openPanel('cart-drawer', buttons[0]);
    } catch (error) {
      if (status) status.textContent = error.message || strings.cartError || '';
    } finally {
      const available = form.dataset.available !== 'false';
      buttons.forEach((button) => { button.disabled = !available; button.removeAttribute('aria-busy'); });
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  /* ----------------------------------------------------- predictive search */
  $$('[data-search-dialog]').forEach((dialog) => {
    const input = $('[data-search-input]', dialog);
    const results = $('[data-search-results]', dialog);
    const count = $('[data-search-count]', dialog);
    const hint = $('[data-search-hint]', dialog);
    if (!input || !results) return;
    let timer = null;
    let controller = null;

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();
      if (!query) {
        controller?.abort();
        results.replaceChildren();
        if (count) count.textContent = '';
        if (hint) hint.hidden = false;
        return;
      }
      timer = window.setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][prefix]': 'last', section_id: 'predictive-search' });
        try {
          const html = await fetch(`${config.predictiveSearchUrl || '/search/suggest'}?${params}`, { signal: controller.signal }).then((response) => response.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const wrapper = doc.querySelector('[data-result-count]');
          results.replaceChildren(...(wrapper ? wrapper.childNodes : []));
          if (hint) hint.hidden = true;
          const total = wrapper ? Number(wrapper.dataset.resultCount) : 0;
          if (count) count.textContent = total ? `${total} ${strings.result || ''}` : '';
        } catch (error) {
          if (error.name !== 'AbortError') results.replaceChildren();
        }
      }, 220);
    });
  });

  /* -------------------------------------------------------------- wishlist */
  const WISHLIST_KEY = 'aksesuarlia:wishlist';
  const readWishlist = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(value) ? value.filter((item) => typeof item === 'string') : [];
    } catch (error) { return []; }
  };
  const writeWishlist = (items) => {
    try { window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (error) { /* storage unavailable */ }
  };

  function syncWishlist() {
    const items = readWishlist();
    $$('[data-wishlist-toggle]').forEach((button) => {
      const on = items.includes(button.dataset.wishlistToggle);
      button.classList.toggle('active', on);
      button.setAttribute('aria-pressed', String(on));
      const label = on ? (button.dataset.labelRemove || strings.removeFavorite) : (button.dataset.labelAdd || strings.addFavorite);
      if (label) button.setAttribute('aria-label', label);
    });
    $$('[data-wishlist-count]').forEach((badge) => { badge.textContent = items.length; badge.hidden = items.length === 0; });
    $$('[data-wishlist-count-plain]').forEach((node) => { node.textContent = items.length; });
    $$('[data-wishlist-link]').forEach((link) => link.setAttribute('aria-label', `${strings.wishlist || ''}, ${items.length}`));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.wishlistToggle;
    const items = readWishlist();
    const next = items.includes(handle) ? items.filter((item) => item !== handle) : [handle, ...items];
    writeWishlist(next);
    syncWishlist();
    const page = $('[data-wishlist-page]');
    if (page && !next.includes(handle)) {
      button.closest('.product-card, article, [data-wishlist-item]')?.remove();
      if (!next.length) { $('[data-wishlist-grid]', page).hidden = true; $('[data-wishlist-empty]', page).hidden = false; }
    }
  });

  window.addEventListener('storage', (event) => { if (event.key === WISHLIST_KEY) syncWishlist(); });

  async function loadWishlistPage(page) {
    const grid = $('[data-wishlist-grid]', page);
    const loading = $('[data-wishlist-loading]', page);
    const empty = $('[data-wishlist-empty]', page);
    const section = page.dataset.cardSection || 'wishlist-card';
    const items = readWishlist();
    const found = [];
    const cards = await Promise.all(items.map(async (handle) => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=${section}`);
        if (!response.ok) return null;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = doc.querySelector('.shopify-section') || doc.body;
        if (!card.children.length) return null;
        found.push(handle);
        const holder = document.createElement('div');
        holder.className = 'wishlist-item';
        holder.dataset.wishlistItem = handle;
        holder.style.display = 'contents';
        holder.append(...card.childNodes);
        return holder;
      } catch (error) { return null; }
    }));
    // Forget products that no longer exist (deleted or unpublished).
    if (found.length !== items.length) writeWishlist(items.filter((handle) => found.includes(handle)));
    const nodes = cards.filter(Boolean);
    grid.replaceChildren(...nodes);
    loading.hidden = true;
    grid.hidden = nodes.length === 0;
    empty.hidden = nodes.length > 0;
    grid.setAttribute('aria-hidden', String(nodes.length === 0));
    empty.setAttribute('aria-hidden', String(nodes.length > 0));
    syncWishlist();
  }

  /* ------------------------------------------------------ product detail */
  const zoom = { modal: null, close: null };

  $$('[data-product-root]').forEach((product) => {
    const productSection = product.closest('.shopify-section') || product.parentElement || document;
    let data = { images: [], variants: [] };
    try { data = JSON.parse($('script[data-product-json]', productSection)?.textContent || '{}'); } catch (error) { /* keep defaults */ }
    const slides = $$('[data-gallery-slide]', product);
    const thumbs = $$('[data-gallery-thumb]', product);
    const total = Math.max(slides.length, (data.images || []).length, 1);
    let active = 0;

    function show(index) {
      active = (index + total) % total;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === active);
        if (i === active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
      $$('[data-gallery-count]', product).forEach((node) => { node.textContent = `${active + 1} / ${total}`; });
      if (zoom.modal) {
        $$('[data-gallery-count]', zoom.modal).forEach((node) => { node.textContent = `${active + 1} / ${total}`; });
        const image = $('[data-zoom-image]', zoom.modal);
        const source = data.images?.[active];
        if (image && source) { image.src = source.src; image.alt = source.alt || ''; }
      }
    }

    const swipeable = (element) => {
      let startX = null;
      element.addEventListener('touchstart', (event) => { startX = event.touches.length === 1 ? event.touches[0].clientX : null; }, { passive: true });
      element.addEventListener('touchend', (event) => {
        if (startX === null || event.changedTouches.length !== 1) return;
        const distance = event.changedTouches[0].clientX - startX;
        if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1));
        startX = null;
      });
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb))));
    $$('[data-gallery-prev]', product).forEach((button) => button.addEventListener('click', () => show(active - 1)));
    $$('[data-gallery-next]', product).forEach((button) => button.addEventListener('click', () => show(active + 1)));
    const main = $('[data-gallery-main]', product);
    if (main) swipeable(main);

    // Zoom modal lives in a <template> so body:has(.zoom-modal) only locks scrolling while open.
    const template = $('template[data-zoom-template]', productSection);
    function closeZoom() {
      if (!zoom.modal) return;
      zoom.modal.remove();
      zoom.modal = null;
      document.removeEventListener('keydown', zoom.keys);
      zoom.trigger?.focus({ preventScroll: true });
    }
    function openZoom(trigger) {
      if (!template || zoom.modal || !(data.images || []).length) return;
      const fragment = template.content.cloneNode(true);
      zoom.modal = fragment.querySelector('[data-zoom-modal]');
      zoom.trigger = trigger;
      document.body.appendChild(fragment);
      $('[data-zoom-close]', zoom.modal).addEventListener('click', closeZoom);
      $$('[data-gallery-prev]', zoom.modal).forEach((button) => button.addEventListener('click', () => show(active - 1)));
      $$('[data-gallery-next]', zoom.modal).forEach((button) => button.addEventListener('click', () => show(active + 1)));
      zoom.modal.addEventListener('click', (event) => { if (event.target === zoom.modal) closeZoom(); });
      const frame = $('.zoom-frame', zoom.modal);
      if (frame) swipeable(frame);
      zoom.keys = (event) => {
        if (event.key === 'Escape') closeZoom();
        if (event.key === 'ArrowLeft') show(active - 1);
        if (event.key === 'ArrowRight') show(active + 1);
        if (event.key === 'Tab') {
          const nodes = focusable(zoom.modal);
          if (!nodes.length) return;
          if (event.shiftKey && document.activeElement === nodes[0]) { event.preventDefault(); nodes[nodes.length - 1].focus(); }
          else if (!event.shiftKey && document.activeElement === nodes[nodes.length - 1]) { event.preventDefault(); nodes[0].focus(); }
        }
      };
      document.addEventListener('keydown', zoom.keys);
      show(active);
      $('[data-zoom-close]', zoom.modal).focus({ preventScroll: true });
    }
    $$('[data-zoom-open]', product).forEach((button) => button.addEventListener('click', () => openZoom(button)));

    // Quantity
    const form = $('[data-product-form]', product);
    if (!form) return;
    const quantityInput = $('[data-quantity-input]', form);
    const quantityDisplay = $('[data-quantity-display]', form);
    $$('[data-qty-step]', form).forEach((button) => button.addEventListener('click', () => {
      const next = Math.min(99, Math.max(1, (Number(quantityInput.value) || 1) + Number(button.dataset.qtyStep)));
      quantityInput.value = next;
      if (quantityDisplay) quantityDisplay.textContent = next;
    }));

    // Variants
    const addButtons = [...$$('[data-add-button]', form), ...$$(`[data-add-button][form="${form.id}"]`)];
    $$('[data-variant-button]', form).forEach((button) => button.addEventListener('click', () => {
      const variant = (data.variants || []).find((item) => String(item.id) === button.dataset.variantButton);
      if (!variant) return;
      $$('[data-variant-button]', form).forEach((other) => other.classList.toggle('active', other === button));
      $('[data-variant-id]', form).value = variant.id;
      form.dataset.available = String(variant.available);
      const current = $('[data-price-current]', product);
      const compare = $('[data-price-compare]', product);
      if (current) current.textContent = formatMoney(variant.price);
      if (compare) { compare.hidden = !(variant.compare > variant.price); compare.textContent = formatMoney(variant.compare); }
      $$('[data-mobile-price]').forEach((node) => { node.textContent = formatMoney(variant.price); });
      const sku = $('[data-variant-sku]', product);
      if (sku) sku.textContent = variant.sku || '—';
      addButtons.forEach((add) => {
        add.disabled = !variant.available;
        const label = $('span', add) || add;
        if (label.children.length === 0) label.textContent = variant.available ? strings.addCart : strings.soldOut;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }));
  });

  /* ------------------------------------------------------ listing controls */
  $$('[data-sort-select]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  $$('[data-product-recommendations]').forEach((section) => {
    if (!section.dataset.url || section.dataset.loaded === 'true') return;
    const load = async () => {
      section.dataset.loaded = 'true';
      try {
        const response = await fetch(section.dataset.url, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const recommendations = html.querySelector('[data-product-recommendations]');
        if (recommendations?.innerHTML.trim()) section.innerHTML = recommendations.innerHTML;
      } catch (error) {
        section.dataset.loaded = 'false';
      }
    };
    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      load();
    }, { rootMargin: '0px 0px 320px' });
    observer.observe(section);
  });

  $$('[data-price-filter]').forEach((form) => {
    const range = $('[data-range-input]', form);
    const output = $('[data-range-output]', form);
    if (!range) return;
    range.addEventListener('input', () => { if (output) output.textContent = formatMoney(Number(range.value) * 100).replace(/[.,]00(?!\d)/, ''); });
    range.addEventListener('change', () => {
      // Leaving the slider at its maximum means "no upper limit".
      if (Number(range.value) >= Number(range.dataset.rangeMax)) range.disabled = true;
      form.submit();
    });
  });

  /* ----------------------------------------------------- legal editorial */
  const normalizeLegalBody = (root) => {
    if (root.dataset.legalReady === 'true') return;
    root.dataset.legalReady = 'true';
    const body = $('[data-legal-body]', root);
    const toc = $('[data-legal-toc]', root);
    const links = $('[data-legal-toc-links]', root);
    if (!body || !toc || !links) return;

    const legacyPolicy = $(':scope > .policy-layout', body);
    if (legacyPolicy) {
      const legacyBody = $(':scope > div', legacyPolicy);
      if (legacyBody) legacyPolicy.replaceWith(...legacyBody.childNodes);
    }

    if (root.dataset.pageHandle === 'iade-ve-degisim') {
      $$(':scope > .returns-lead, :scope > .return-steps', body).forEach((section) => {
        const fragment = document.createDocumentFragment();
        Array.from(section.childNodes).forEach((node) => {
          if (node.nodeType === 1 && node.matches('div')) Array.from(node.childNodes).forEach((child) => fragment.append(child));
          else fragment.append(node);
        });
        section.replaceWith(fragment);
      });
      $$(':scope > article', body).forEach((article) => article.replaceWith(...article.childNodes));
    }

    const slugCounts = new Map();
    const headings = $$('h2, h3', body).filter((heading) => heading.textContent.trim());
    headings.forEach((heading, index) => {
      let id = heading.id.trim();
      if (!id) {
        const base = heading.textContent.trim().toLocaleLowerCase(document.documentElement.lang || 'tr')
          .normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i')
          .replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '') || `bolum-${index + 1}`;
        const count = (slugCounts.get(base) || 0) + 1;
        slugCounts.set(base, count);
        id = count > 1 ? `${base}-${count}` : base;
        heading.id = id;
      }
      heading.classList.add('legal-editorial__heading');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(id)}`;
      link.textContent = heading.textContent.trim();
      if (heading.tagName === 'H3') link.className = 'is-subheading';
      links.append(link);
    });
    if (headings.length) toc.hidden = false;
  };

  const nativePolicy = $('[data-native-policy]');
  if (nativePolicy) {
    const container = $('.shopify-policy__container', nativePolicy);
    const title = $('.shopify-policy__title h1', nativePolicy);
    const sourceBody = $('.shopify-policy__body .rte', nativePolicy);
    if (container && title && sourceBody) {
      const breadcrumb = document.createElement('nav');
      breadcrumb.className = 'breadcrumbs shell content-breadcrumb';
      breadcrumb.setAttribute('aria-label', nativePolicy.dataset.breadcrumbLabel || 'Breadcrumb');
      breadcrumb.innerHTML = `<a href="${config.rootUrl || '/'}">${nativePolicy.dataset.homeLabel || 'Home'}</a><span>/</span><span></span>`;
      breadcrumb.lastElementChild.textContent = title.textContent.trim();

      const hero = document.createElement('header');
      hero.className = 'content-hero';
      const heroShell = document.createElement('div');
      heroShell.className = 'shell';
      const heroCopy = document.createElement('div');
      heroCopy.append(title);
      heroShell.append(heroCopy);
      hero.append(heroShell);

      const shell = document.createElement('div');
      shell.className = 'legal-editorial shell';
      shell.dataset.legalEditorial = '';
      shell.dataset.tocLabel = nativePolicy.dataset.tocLabel || '';
      const toc = document.createElement('aside');
      toc.className = 'legal-editorial__toc';
      toc.dataset.legalToc = '';
      toc.hidden = true;
      const tocTitle = document.createElement('span');
      tocTitle.textContent = shell.dataset.tocLabel;
      const tocLinks = document.createElement('nav');
      tocLinks.dataset.legalTocLinks = '';
      tocLinks.setAttribute('aria-label', shell.dataset.tocLabel);
      toc.append(tocTitle, tocLinks);
      sourceBody.className = 'legal-editorial__body rte';
      sourceBody.dataset.legalBody = '';
      shell.append(toc, sourceBody);
      nativePolicy.replaceWith(breadcrumb, hero, shell);
    }
  }
  $$('[data-legal-editorial]').forEach(normalizeLegalBody);

  /* ----------------------------------------------------------------- misc */
  $$('.article-toc').forEach((toc) => {
    const title = $(':scope > span', toc);
    if (title && !$('.article-toc-toggle', toc)) {
      title.classList.add('article-toc-title');
      const list = $('ol', toc);
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'article-toc-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      if (list) {
        if (!list.id) list.id = `article-toc-${Math.random().toString(36).slice(2)}`;
        toggle.setAttribute('aria-controls', list.id);
      }
      toggle.innerHTML = `<span>${title.textContent}</span><svg aria-hidden="true" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      toggle.addEventListener('click', () => {
        const open = toc.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
      $$('a[href^="#"]', toc).forEach((link) => link.addEventListener('click', () => {
        toc.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }));
      title.after(toggle);
    }
    const links = $$('a[href^="#"]', toc);
    const sections = links.map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean);
    if (!sections.length || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (!visible) return;
      links.forEach((link) => {
        const active = link.hash === `#${visible.target.id}`;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
      });
    }, { rootMargin: '-22% 0px -66% 0px' });
    sections.forEach((section) => observer.observe(section));
  });

  $$('[data-back-to-top]').forEach((button) => button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    ($('#main-content') || document.body).focus?.({ preventScroll: true });
  }));

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-confirm]');
    if (form && !window.confirm(form.dataset.confirm)) event.preventDefault();
  });

  const recoverPanel = $('[data-recover-panel]');
  if (recoverPanel) {
    const loginPanel = $('[data-login-panel]');
    const setRecover = (on) => {
      recoverPanel.hidden = !on;
      if (loginPanel) loginPanel.hidden = on;
      if (on) $('input[type="email"]', recoverPanel)?.focus({ preventScroll: true });
    };
    if (window.location.hash === '#recover' || $('[data-recover-success], [data-recover-error]', recoverPanel)) setRecover(true);
    $$('[data-recover-toggle]').forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      setRecover(recoverPanel.hidden);
    }));
  }

  syncWishlist();
  const wishlistPage = $('[data-wishlist-page]');
  if (wishlistPage) loadWishlistPage(wishlistPage);

  // Keep the header count right when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', (event) => { if (event.persisted) { refreshCart(); syncWishlist(); } });
})();
